// import React, { useState, useEffect } from "react";
// import { useParams } from "react-router-dom";
// import axios from "../Axiosinstance";
// import Head from "./Headstu";
// import {
//   Typography,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Button,
//   Box,
//   Card,
//   TablePagination,
//   TextField,
//   MenuItem,
// } from "@mui/material";
// import { CloudUpload, Visibility } from "@mui/icons-material";
// import { CLOUDINARY_UPLOAD_PRESET, baseURL } from '../common'
// import { decryptData } from "../Axiosinstance";

// const BatchTable = () => {
//   const { id: encryptedId, intakeId: encryptedIntakeId } = useParams();
//   const id = decryptData(encryptedId);
//   const intakeId = decryptData(encryptedIntakeId);

//   console.log(id, intakeId, "new ");
//   const [uploadedFiles, setUploadedFiles] = useState({});
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(5);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedModule, setSelectedModule] = useState("");
//   const [rows, setRows] = useState([]);
//   const [batchData, setBatchData] = useState(null);
//   const [answersData, setAnswersData] = useState(null);
//   const [submittedAnswers, setSubmittedAnswers] = useState({});

//   const studentTeacherId = parseInt(decryptData(localStorage.getItem("studentteacherid")), 10);
//   console.log(typeof studentTeacherId);
//   const CLOUDINARY_UPLOAD = CLOUDINARY_UPLOAD_PRESET;


//   useEffect(() => {
//     fetchAssessmentData();
//     fetchBatchData();
//     fetchAnswers();
//   }, [id]);

//   useEffect(() => {
//     if (answersData) {
//       // Store submitted answers with additional details
//       const submittedData = {};
//       answersData.forEach((answer) => {
//         submittedData[answer.trentAssessmentId] = {
//           url: answer.url,
//           approver: answer.approver || "N/A",
//           comments: answer.comments || "N/A",
//           grade: answer.grade || "N/A",
//         };
//       });
//       setSubmittedAnswers(submittedData);
//       console.log("submittedData",submittedData)
//     }
//   }, [answersData]);

//   const fetchAssessmentData = async () => {
//     try {
//       const response = await axios.get(`trent_assessments/${id}`);
//       setRows(response.data);
//     } catch (error) {
//       console.error("Error fetching assessments:", error);
//     }
//   };

//   const fetchBatchData = async () => {
//     try {
//       const response = await axios.get(`batch/${id}`);
//       setBatchData(response.data);
//     } catch (error) {
//       console.error("Error fetching batch data:", error);
//     }
//   };

//   const fetchAnswers = async () => {
//     try {
//       const response = await axios.get(`submissions/student/${studentTeacherId}`);
//       setAnswersData(response.data);
//     } catch (error) {
//       console.error("Error fetching answers:", error);
//     }
//   };

//   const handleFileUpload = async (event, assessmentId, moduleName) => {
//     const file = event.target.files[0];
//     if (!file) return;

//     const formData = new FormData();
//     formData.append("file", file);
//     formData.append("upload_preset", CLOUDINARY_UPLOAD);
//     formData.append("public_id", `LMS/Trent/${file.name}`);

//     try {
//       const response = await fetch(baseURL, {
//         method: "POST",
//         body: formData,
//       });

//       const data = await response.json();

//       if (data.secure_url) {
//         const fileUrl = data.secure_url;

//         const confirmUpload = window.confirm("Are you sure you want to submit this file?");
//         if (confirmUpload) {
//           const submissionData = {
//             studentId: studentTeacherId,
//             trentAssessmentId: assessmentId,
//             url: fileUrl,
//             batchId: id,
//             intakeId: intakeId,
//             moduleName: moduleName
//           };

//           await axios.post("submissions/upload", submissionData);

//           setUploadedFiles((prev) => ({
//             ...prev,
//             [assessmentId]: fileUrl,
//           }));

//           alert("File uploaded and submitted successfully!");
//           fetchAnswers();
//         }
//       }
//     } catch (error) {
//       console.error("File upload failed:", error);
//       alert("File upload failed. Please try again.");
//     }
//   };

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   const filteredData = rows.filter(
//     (row) =>
//       row.moduleName.toLowerCase().includes(searchTerm.toLowerCase()) &&
//       (selectedModule === "" || row.moduleName === selectedModule)
//   );

//   return (
//     <div style={{ textAlign: "center", marginTop: "2%" }}>
//       <Head />
//       <Card sx={{ maxWidth: "1300px", margin: "auto" }}>
//         <Typography
//           variant="h4"
//           fontWeight="bold"
//           gutterBottom
//           sx={{
//             color: "primary.main",
//             textDecoration: "underline",
//             textUnderlineOffset: "6px",
//             letterSpacing: "1px",
//             textAlign: "center",
//             mt: 3,
//             mb: 4,
//             fontSize: "2rem",
//           }}
//         >
//           {batchData?.name || "Batch Assessments"}
//         </Typography>

//         <Box display="flex" justifyContent="space-between" sx={{ mb: 2, px: 2, gap: 2 }}>
//           <TextField
//             label="Search Module"
//             variant="outlined"
//             size="small"
//             fullWidth
//             onChange={(e) => setSearchTerm(e.target.value)}
//             sx={{ flex: 1 }}
//           />
//           <TextField
//             select
//             label="Filter by Module"
//             value={selectedModule}
//             onChange={(e) => setSelectedModule(e.target.value)}
//             variant="outlined"
//             size="small"
//             fullWidth
//             sx={{ flex: 1 }}
//           >
//             <MenuItem value="">All Modules</MenuItem>
//             {batchData?.moduleDetails.map((row) => (
//               <MenuItem key={row.id} value={row.moduleName}>
//                 {row.moduleName}
//               </MenuItem>
//             ))}
//           </TextField>
//         </Box>

//         <TableContainer component={Paper} sx={{ boxShadow: 3 }}>
//           <Table>
//             <TableHead>
//               <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
//                 {/* <TableCell sx={{ fontWeight: "bold" }}>Batch ID</TableCell> */}
//                 <TableCell sx={{ fontWeight: "bold" }}>Module Name</TableCell>
//                 <TableCell sx={{ fontWeight: "bold" }}>Description</TableCell>
//                 <TableCell sx={{ fontWeight: "bold" }}>Mark</TableCell>
//                 {/* <TableCell sx={{ fontWeight: "bold" }}>Comments</TableCell> */}
//                 <TableCell sx={{ fontWeight: "bold" }}>Approver</TableCell>
//                 <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>Action</TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {filteredData.length === 0 ? (
//                 <TableRow>
//                   <TableCell colSpan={4} align="center">
//                     <Typography variant="body1" color="textSecondary">
//                       No data available
//                     </Typography>
//                   </TableCell>
//                 </TableRow>
//               ) : (
//                 filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
//                   const answerDetails = submittedAnswers[row.id] || {}; // Get saved data

//                   return (
//                     <TableRow key={row.id}>
//                       {/* <TableCell>{row.batchId}</TableCell> */}
//                       <TableCell>{row.moduleName}</TableCell>
//                       <TableCell>{row.description}</TableCell>
//                       <TableCell>{answerDetails.grade || "N/A"}/100</TableCell>
//                       {/* <TableCell>{answerDetails.comments || "N/A"}</TableCell> */}
//                       <TableCell>{answerDetails.approver || "N/A"}</TableCell>
//                       <TableCell align="center">
//                         <Button
//                           variant="contained"
//                           color="primary"
//                           onClick={() => window.open(row.url, "_blank")}
//                         >
//                           View Question
//                         </Button>

//                         {!answerDetails.url ? (
//                           <>
//                             <input
//                               type="file"
//                               accept=".pdf,.doc,.docx"
//                               style={{ display: "none" }}
//                               id={`file-upload-${row.id}`}
//                               onChange={(e) => {
//                                 const file = e.target.files[0];
//                                 if (file && file.size > 8 * 1024 * 1024) {
//                                   e.target.value = ""; // Reset file input
//                                   alert("File size must be less than 8MB.");
//                                 } else {
//                                   handleFileUpload(e, row.id, row.moduleName);
//                                 }
//                               }}
//                             />
//                             <label htmlFor={`file-upload-${row.id}`}>
//                               <Button
//                                 variant="contained"
//                                 color="secondary"
//                                 component="span"
//                                 startIcon={<CloudUpload />}
//                                 sx={{ ml: 2 }}
//                               >
//                                 Upload Assessment
//                               </Button>
//                             </label>
//                           </>
//                         ) : (
//                           <Button
//                             variant="contained"
//                             color="success"
//                             startIcon={<Visibility />}
//                             onClick={() => window.open(answerDetails.url, "_blank")}
//                             sx={{ ml: 2 }}
//                           >
//                             View Submission
//                           </Button>
//                         )}
//                       </TableCell>
//                     </TableRow>
//                   );
//                 })
//               )}
//             </TableBody>
//           </Table>
//         </TableContainer>
//       </Card>
//     </div>
//   );
// };

// export default BatchTable;




import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "../Axiosinstance";
import Head from "./Headstu";
import {
  Typography, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, Button, Box, Card, TablePagination,
  TextField, MenuItem, Radio, RadioGroup, FormControlLabel,
  Chip, Dialog, DialogTitle, DialogContent, DialogActions,
  LinearProgress, Divider, CircularProgress
} from "@mui/material";
import { CloudUpload, Visibility, Quiz, CheckCircle, Cancel, Lock } from "@mui/icons-material";
import { CLOUDINARY_UPLOAD_PRESET, baseURL } from '../common';
import { decryptData } from "../Axiosinstance";
import { toast, ToastContainer } from 'react-toastify';

// ─────────────────────────────────────────────────────────────────
// QuizReviewDialog — shows student answers vs correct answers
// ─────────────────────────────────────────────────────────────────
const QuizReviewDialog = ({ open, onClose, assessmentId, studentId, assessmentName }) => {
  const [questions, setQuestions]   = useState([]);
  const [myAnswers, setMyAnswers]   = useState([]);
  const [loading, setLoading]       = useState(false);

  useEffect(() => {
    if (open && assessmentId && studentId) {
      fetchReviewData();
    }
  }, [open, assessmentId, studentId]);

  const fetchReviewData = async () => {
    setLoading(true);
    try {
      const [qRes, aRes] = await Promise.all([
        axios.get(`assessment_questions/${assessmentId}`),
        axios.get(`quiz/results/${studentId}/${assessmentId}`),
      ]);
      setQuestions(qRes.data);
      setMyAnswers(aRes.data);
    } catch (err) {
      console.error("Error loading review:", err);
      toast.error("Failed to load quiz review");
    } finally {
      setLoading(false);
    }
  };

  const totalMarks  = questions.reduce((s, q) => s + (q.marks || 0), 0);
  const earnedMarks = myAnswers.reduce((s, a) => s + (a.marksAwarded || 0), 0);
  const percentage  = totalMarks > 0 ? (earnedMarks / totalMarks) * 100 : 0;

  const getMyAnswer = (questionId) =>
    myAnswers.find(a => a.questionId === questionId);

  const getCorrectOption = (question) =>
    question.options?.find(o => o.isCorrect)?.optionText || 'N/A';

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth
      PaperProps={{ sx: { maxHeight: '90vh' } }}>
      <DialogTitle sx={{ borderBottom: '1px solid #e0e0e0', pb: 2 }}>
        <Typography variant="h6" fontWeight="bold">Quiz Review</Typography>
        <Typography variant="body2" color="textSecondary">{assessmentName}</Typography>
      </DialogTitle>

      <DialogContent sx={{ p: 3 }}>
        {loading ? (
          <Box display="flex" justifyContent="center" py={6}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            {/* ── Score Summary ─────────────────────────────────── */}
            <Box sx={{
              background: percentage >= 50
                ? 'linear-gradient(135deg,#e8f5e9,#c8e6c9)'
                : 'linear-gradient(135deg,#ffebee,#ffcdd2)',
              borderRadius: 2, p: 3, mb: 3, textAlign: 'center'
            }}>
              <Typography variant="h3" fontWeight="bold"
                color={percentage >= 50 ? 'success.main' : 'error.main'}>
                {earnedMarks} / {totalMarks}
              </Typography>
              <Typography variant="h6" color="textSecondary">
                {percentage.toFixed(1)}%
              </Typography>
              <LinearProgress variant="determinate" value={percentage}
                sx={{ mt: 1.5, height: 12, borderRadius: 6 }}
                color={percentage >= 50 ? 'success' : 'error'} />
              <Typography mt={1.5} fontWeight="bold"
                color={percentage >= 50 ? 'success.main' : 'error.main'}>
                {percentage >= 50 ? '🎉 Passed!' : '❌ Failed — Keep Practicing!'}
              </Typography>
            </Box>

            {/* ── Per-question review ───────────────────────────── */}
            {questions.map((q, index) => {
              const myAnswer = getMyAnswer(q.id);
              const isCorrect = myAnswer?.isCorrect;
              const myAnswerText = myAnswer?.answer || 'No answer given';

              return (
                <Box key={q.id} sx={{
                  border: `2px solid ${isCorrect ? '#4caf50' : '#f44336'}`,
                  borderRadius: 2, p: 2.5, mb: 2,
                  backgroundColor: isCorrect ? '#f9fff9' : '#fff9f9'
                }}>
                  {/* Question header */}
                  <Box display="flex" justifyContent="space-between"
                    alignItems="flex-start" mb={1.5}>
                    <Box sx={{ flex: 1 }}>
                      <Typography fontWeight="bold">
                        Q{index + 1}. {q.questionText}
                      </Typography>
                      <Box display="flex" gap={1} mt={0.5}>
                        <Chip label={q.questionType} size="small" variant="outlined" />
                        <Chip label={`${q.marks} mark${q.marks > 1 ? 's' : ''}`}
                          size="small" color="info" variant="outlined" />
                      </Box>
                    </Box>
                    <Chip
                      icon={isCorrect ? <CheckCircle /> : <Cancel />}
                      label={isCorrect
                        ? `+${myAnswer?.marksAwarded}`
                        : `0 / ${q.marks}`}
                      color={isCorrect ? 'success' : 'error'}
                      sx={{ ml: 1, fontWeight: 'bold', fontSize: '0.9rem' }}
                    />
                  </Box>

                  <Divider sx={{ mb: 1.5 }} />

                  {/* MCQ — show all options */}
                  {q.questionType === 'MCQ' && (
                    <Box>
                      {q.options?.map((opt, i) => {
                        const isMyChoice = myAnswerText === opt.optionText;
                        const isRight    = opt.isCorrect;
                        let bg = 'transparent';
                        if (isRight)    bg = '#e8f5e9';
                        if (isMyChoice && !isRight) bg = '#ffebee';

                        return (
                          <Box key={i} display="flex" alignItems="center"
                            gap={1} mb={0.5} sx={{
                              backgroundColor: bg,
                              borderRadius: 1, px: 1, py: 0.5
                            }}>
                            {isRight && <CheckCircle sx={{ color: 'green', fontSize: 18 }} />}
                            {isMyChoice && !isRight && <Cancel sx={{ color: 'red', fontSize: 18 }} />}
                            {!isRight && !isMyChoice && <Box sx={{ width: 18 }} />}
                            <Typography variant="body2"
                              sx={{ fontWeight: (isRight || isMyChoice) ? 'bold' : 'normal' }}>
                              {opt.optionText}
                              {isMyChoice && !isRight && (
                                <Chip label="Your answer" size="small"
                                  color="error" sx={{ ml: 1, height: 18 }} />
                              )}
                              {isRight && (
                                <Chip label="Correct" size="small"
                                  color="success" sx={{ ml: 1, height: 18 }} />
                              )}
                            </Typography>
                          </Box>
                        );
                      })}
                    </Box>
                  )}

                  {/* TRUE/FALSE */}
                  {q.questionType === 'TRUE_FALSE' && (
                    <Box display="flex" gap={2}>
                      {['True', 'False'].map(val => {
                        const isMyChoice = myAnswerText === val;
                        const correctAnswer = getCorrectOption(q);
                        const isRight = val === correctAnswer;
                        return (
                          <Box key={val} sx={{
                            border: `2px solid ${isRight ? '#4caf50' : isMyChoice ? '#f44336' : '#e0e0e0'}`,
                            borderRadius: 1, px: 2, py: 1,
                            backgroundColor: isRight ? '#e8f5e9' : isMyChoice ? '#ffebee' : 'transparent'
                          }}>
                            <Typography fontWeight={isMyChoice || isRight ? 'bold' : 'normal'}>
                              {val}
                              {isMyChoice && !isRight && ' ✗ (Your answer)'}
                              {isRight && ' ✓ (Correct)'}
                            </Typography>
                          </Box>
                        );
                      })}
                    </Box>
                  )}

                  {/* MATCH */}
                  {q.questionType === 'MATCH' && (() => {
                    let studentMap = {};
                    try {
                      studentMap = JSON.parse(myAnswerText);
                    } catch (_) {}

                    return (
                      <Box>
                        <Box display="flex" gap={1} mb={1}>
                          <Typography variant="caption" fontWeight="bold"
                            sx={{ flex: 1, textAlign: 'center' }}>LEFT</Typography>
                          <Typography variant="caption" fontWeight="bold"
                            sx={{ width: 100, textAlign: 'center' }}>YOUR ANSWER</Typography>
                          <Typography variant="caption" fontWeight="bold"
                            sx={{ width: 100, textAlign: 'center' }}>CORRECT</Typography>
                          <Typography variant="caption" fontWeight="bold"
                            sx={{ width: 60, textAlign: 'center' }}>RESULT</Typography>
                        </Box>
                        {q.matchPairs?.map((pair, pi) => {
                          const studentRight = studentMap[pair.leftItem] || 'No answer';
                          const pairCorrect  = studentRight === pair.rightItem;
                          return (
                            <Box key={pi} display="flex" gap={1} mb={0.5}
                              alignItems="center" sx={{
                                backgroundColor: pairCorrect ? '#e8f5e9' : '#ffebee',
                                borderRadius: 1, px: 1, py: 0.5
                              }}>
                              <Typography variant="body2" sx={{ flex: 1, fontWeight: 'bold' }}>
                                {pair.leftItem}
                              </Typography>
                              <Typography variant="body2" sx={{ width: 100, textAlign: 'center',
                                color: pairCorrect ? 'success.main' : 'error.main' }}>
                                {studentRight}
                              </Typography>
                              <Typography variant="body2" sx={{ width: 100, textAlign: 'center',
                                color: 'success.main', fontWeight: 'bold' }}>
                                {pair.rightItem}
                              </Typography>
                              <Box sx={{ width: 60, textAlign: 'center' }}>
                                {pairCorrect
                                  ? <CheckCircle sx={{ color: 'green', fontSize: 18 }} />
                                  : <Cancel sx={{ color: 'red', fontSize: 18 }} />}
                              </Box>
                            </Box>
                          );
                        })}
                      </Box>
                    );
                  })()}

                  {/* SHORT ANSWER */}
                  {q.questionType === 'SHORT_ANSWER' && (
                    <Box>
                      <Typography variant="body2" color="textSecondary" mb={0.5}>
                        Your Answer:
                      </Typography>
                      <Box sx={{
                        backgroundColor: '#f5f5f5', borderRadius: 1,
                        p: 1.5, border: '1px solid #e0e0e0'
                      }}>
                        <Typography variant="body2">{myAnswerText}</Typography>
                      </Box>
                      <Chip label="Manually graded by teacher"
                        size="small" color="warning" sx={{ mt: 1 }} />
                    </Box>
                  )}
                </Box>
              );
            })}
          </>
        )}
      </DialogContent>

      <DialogActions sx={{ p: 2, borderTop: '1px solid #e0e0e0' }}>
        <Button onClick={onClose} variant="contained">Close</Button>
      </DialogActions>
    </Dialog>
  );
};

// ─────────────────────────────────────────────────────────────────
// Main BatchTable component
// ─────────────────────────────────────────────────────────────────
const BatchTable = () => {
  const { id: encryptedId, intakeId: encryptedIntakeId } = useParams();
  const id       = decryptData(encryptedId);
  const intakeId = decryptData(encryptedIntakeId);

  // ── Alumni check ─────────────────────────────────────────────
  const studentStatus = decryptData(localStorage.getItem('status'));
  const isAlumni      = studentStatus === 'Alumni';

  const [rows, setRows]                     = useState([]);
  const [batchData, setBatchData]           = useState(null);
  const [answersData, setAnswersData]       = useState([]);
  const [submittedAnswers, setSubmittedAnswers] = useState({});
  const [submittedQuizIds, setSubmittedQuizIds] = useState({});
  const [quizScores, setQuizScores]         = useState({});

  const [page, setPage]                     = useState(0);
  const [rowsPerPage, setRowsPerPage]       = useState(5);
  const [searchTerm, setSearchTerm]         = useState("");
  const [selectedModule, setSelectedModule] = useState("");

  // Quiz attempt dialog
  const [quizOpen, setQuizOpen]             = useState(false);
  const [quizAssessment, setQuizAssessment] = useState(null);
  const [quizQuestions, setQuizQuestions]   = useState([]);
  const [studentAnswers, setStudentAnswers] = useState({});
  const [quizSubmitting, setQuizSubmitting] = useState(false);
  const [quizResult, setQuizResult]         = useState(null);
  const [quizResultOpen, setQuizResultOpen] = useState(false);

  // Review dialog
  const [reviewOpen, setReviewOpen]                     = useState(false);
  const [reviewAssessmentId, setReviewAssessmentId]     = useState(null);
  const [reviewAssessmentName, setReviewAssessmentName] = useState('');

  const studentTeacherId = parseInt(
    decryptData(localStorage.getItem("studentteacherid")), 10
  );
  const CLOUDINARY_UPLOAD = CLOUDINARY_UPLOAD_PRESET;

  useEffect(() => {
    fetchAssessmentData();
    fetchBatchData();
    fetchFileAnswers();
    fetchQuizSubmissions();
  }, [id]);

  useEffect(() => {
    if (answersData.length > 0) {
      const map = {};
      answersData.forEach(a => {
        map[a.trentAssessmentId] = {
          url: a.url, approver: a.approver || "N/A",
          comments: a.comments || "N/A", grade: a.grade || "N/A",
        };
      });
      setSubmittedAnswers(map);
    }
  }, [answersData]);

  const fetchAssessmentData = async () => {
    try {
      const res = await axios.get(`trent_assessments/${id}`);
      setRows(res.data);
    } catch (err) { console.error(err); }
  };

  const fetchBatchData = async () => {
    try {
      const res = await axios.get(`batch/${id}`);
      setBatchData(res.data);
    } catch (err) { console.error(err); }
  };

  const fetchFileAnswers = async () => {
    try {
      const res = await axios.get(`submissions/student/${studentTeacherId}`);
      setAnswersData(res.data);
    } catch (err) { console.error(err); }
  };

  const fetchQuizSubmissions = async () => {
    try {
      const res = await axios.get(`quiz/student/${studentTeacherId}`);
      const submitted = {};
      const scores    = {};

      const grouped = {};
      res.data.forEach(ans => {
        if (!grouped[ans.trentAssessmentId]) grouped[ans.trentAssessmentId] = [];
        grouped[ans.trentAssessmentId].push(ans);
      });

      Object.keys(grouped).forEach(assessmentId => {
        submitted[assessmentId] = true;
        const earned = grouped[assessmentId].reduce(
          (s, a) => s + (a.marksAwarded || 0), 0
        );
        scores[assessmentId] = earned;
      });

      setSubmittedQuizIds(submitted);
      setQuizScores(scores);
    } catch (err) {
      console.error("Error fetching quiz submissions:", err);
    }
  };

  // ── Open quiz attempt (blocked for alumni) ───────────────────
  const handleOpenQuiz = async (row) => {
    if (isAlumni) return; // safety guard — button won't render for alumni anyway
    try {
      const res = await axios.get(`assessment_questions/${row.id}`);
      setQuizQuestions(res.data);
      setQuizAssessment(row);
      setStudentAnswers({});
      setQuizResult(null);
      setQuizOpen(true);
    } catch (err) {
      toast.error("Failed to load quiz questions.");
    }
  };

  // ── Open review ──────────────────────────────────────────────
  const handleOpenReview = (row) => {
    setReviewAssessmentId(row.id);
    setReviewAssessmentName(row.description);
    setReviewOpen(true);
  };

  const handleAnswerChange = (questionId, value) =>
    setStudentAnswers(prev => ({ ...prev, [questionId]: value }));

  const handleMatchChange = (questionId, leftItem, rightValue) => {
    setStudentAnswers(prev => {
      const existing = prev[questionId] ? JSON.parse(prev[questionId]) : {};
      existing[leftItem] = rightValue;
      return { ...prev, [questionId]: JSON.stringify(existing) };
    });
  };

  // ── Submit quiz (blocked for alumni) ────────────────────────
  const handleSubmitQuiz = async () => {
    if (isAlumni) return; // safety guard
    if (!window.confirm("Submit the quiz? You cannot change your answers after submitting."))
      return;

    setQuizSubmitting(true);
    try {
      const answers = quizQuestions.map(q => ({
        questionId: q.id,
        answer: studentAnswers[q.id] || '',
      }));

      const res = await axios.post('quiz/submit', {
        studentId: studentTeacherId,
        trentAssessmentId: quizAssessment.id,
        batchId: id,
        intakeId,
        answers,
      });

      setQuizResult(res.data);
      setQuizOpen(false);
      setQuizResultOpen(true);
      fetchQuizSubmissions();
      toast.success("Quiz submitted successfully!");
    } catch (err) {
      if (err.response?.status === 400) {
        toast.error("You have already submitted this quiz.");
      } else {
        toast.error("Submission failed. Please try again.");
      }
    } finally {
      setQuizSubmitting(false);
    }
  };

  // ── File upload (blocked for alumni) ────────────────────────
  const handleFileUpload = async (event, assessmentId, moduleName) => {
    if (isAlumni) return; // safety guard
    const file = event.target.files[0];
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    fd.append("upload_preset", CLOUDINARY_UPLOAD);
    fd.append("public_id", `LMS/Trent/${file.name}`);
    try {
      const res  = await fetch(baseURL, { method: "POST", body: fd });
      const data = await res.json();
      if (data.secure_url) {
        if (!window.confirm("Submit this file?")) return;
        await axios.post("submissions/upload", {
          studentId: studentTeacherId,
          trentAssessmentId: assessmentId,
          url: data.secure_url,
          batchId: id, intakeId, moduleName,
        });
        toast.success("File submitted!");
        fetchFileAnswers();
      }
    } catch (err) {
      toast.error("File upload failed.");
    }
  };

  const getRightItems = (question) =>
    question.matchPairs?.map(p => p.rightItem) || [];

  const filteredData = rows.filter(row =>
    row.moduleName.toLowerCase().includes(searchTerm.toLowerCase()) &&
    (selectedModule === "" || row.moduleName === selectedModule)
  );

  // ── Render action cell based on alumni status ────────────────
  const renderActionCell = (row) => {
    const isQuiz      = row.assessmentType === 'QUIZ';
    const quizSubmitted = submittedQuizIds[row.id];
    const fileDetails   = submittedAnswers[row.id] || {};

    if (isQuiz) {
      if (quizSubmitted) {
        // Both alumni and active students can review submitted quizzes
        return (
          <Button
            variant="contained"
            color="success"
            startIcon={<Visibility />}
            onClick={() => handleOpenReview(row)}
          >
            View Score & Answers
          </Button>
        );
      }

      if (isAlumni) {
        // Alumni: quiz was never attempted — locked
        return (
          <Chip
            icon={<Lock sx={{ fontSize: '14px !important' }} />}
            label="Not Available"
            color="default"
            size="small"
            sx={{ opacity: 0.7 }}
          />
        );
      }

      // Active student: not yet attempted
      return (
        <Button
          variant="contained"
          color="secondary"
          startIcon={<Quiz />}
          onClick={() => handleOpenQuiz(row)}
        >
          Start Quiz
        </Button>
      );
    }

    // ── FILE type ──────────────────────────────────────────────
    return (
      <Box display="flex" alignItems="center" justifyContent="center" gap={1} flexWrap="wrap">
        {/* View question — always visible */}
        <Button
          variant="contained"
          color="primary"
          onClick={() => window.open(row.url, "_blank")}
        >
          View Question
        </Button>

        {fileDetails.url ? (
          // Submission exists — anyone can view it
          <Button
            variant="contained"
            color="success"
            startIcon={<Visibility />}
            onClick={() => window.open(fileDetails.url, "_blank")}
          >
            View Submission
          </Button>
        ) : isAlumni ? (
          // Alumni: no submission — locked, no upload allowed
          <Chip
            icon={<Lock sx={{ fontSize: '14px !important' }} />}
            label="Not Submitted"
            color="default"
            size="small"
            sx={{ opacity: 0.7 }}
          />
        ) : (
          // Active student: allow upload
          <>
            <input
              type="file"
              accept=".pdf,.doc,.docx"
              style={{ display: "none" }}
              id={`file-${row.id}`}
              onChange={e => {
                const f = e.target.files[0];
                if (f && f.size > 8 * 1024 * 1024) {
                  e.target.value = "";
                  alert("Max 8MB");
                } else {
                  handleFileUpload(e, row.id, row.moduleName);
                }
              }}
            />
            <label htmlFor={`file-${row.id}`}>
              <Button
                variant="contained"
                color="secondary"
                component="span"
                startIcon={<CloudUpload />}
              >
                Upload
              </Button>
            </label>
          </>
        )}
      </Box>
    );
  };

  return (
    <div style={{ textAlign: "center", marginTop: "2%" }}>
      <Head />

      {/* Alumni notice banner */}
      {isAlumni && (
        <Box sx={{
          maxWidth: "1300px",
          margin: "0 auto 16px auto",
          px: 2,
        }}>
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            backgroundColor: '#fff8e1',
            border: '1px solid #ffe082',
            borderRadius: 2,
            px: 2.5,
            py: 1.5,
          }}>
            <Lock sx={{ color: '#f57f17', fontSize: 20 }} />
            <Typography variant="body2" color="#5d4037" fontWeight={500}>
              You are viewing this page as an alumni. Assessments are read-only — quiz attempts and file uploads are disabled.
            </Typography>
          </Box>
        </Box>
      )}

      <Card sx={{ maxWidth: "1300px", margin: "auto", mb: 4 }}>
        <Typography variant="h4" fontWeight="bold"
          sx={{ color: "primary.main", textAlign: "center", mt: 3, mb: 4 }}>
          {batchData?.name || "Batch Assessments"}
        </Typography>

        {/* Search + filter */}
        <Box display="flex" sx={{ mb: 2, px: 2, gap: 2 }}>
          <TextField label="Search Module" variant="outlined" size="small"
            fullWidth onChange={e => setSearchTerm(e.target.value)} />
          <TextField select label="Filter by Module" value={selectedModule}
            onChange={e => setSelectedModule(e.target.value)}
            variant="outlined" size="small" fullWidth>
            <MenuItem value="">All Modules</MenuItem>
            {batchData?.moduleDetails?.map(m => (
              <MenuItem key={m.id} value={m.moduleName}>{m.moduleName}</MenuItem>
            ))}
          </TextField>
        </Box>

        <TableContainer component={Paper} sx={{ boxShadow: 3 }}>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                <TableCell sx={{ fontWeight: "bold" }}>Module</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Type</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Description</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Score</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Approver</TableCell>
                <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>
                  Action
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {filteredData.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    <Typography color="textSecondary">No data available</Typography>
                  </TableCell>
                </TableRow>
              ) : (
                filteredData
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map(row => {
                    const isQuiz      = row.assessmentType === 'QUIZ';
                    const quizSubmitted = submittedQuizIds[row.id];
                    const quizScore   = quizScores[row.id];
                    const fileDetails = submittedAnswers[row.id] || {};

                    return (
                      <TableRow key={row.id}>
                        <TableCell>{row.moduleName}</TableCell>
                        <TableCell>
                          <Chip
                            label={row.assessmentType || 'FILE'}
                            color={isQuiz ? 'secondary' : 'primary'}
                            size="small"
                          />
                        </TableCell>
                        <TableCell>{row.description}</TableCell>

                        {/* Score column */}
                        <TableCell>
                          {isQuiz ? (
                            quizSubmitted ? (
                              <Chip
                                label={`${quizScore} pts`}
                                color="success" size="small"
                                icon={<CheckCircle />}
                              />
                            ) : (
                              <Chip label="Not attempted"
                                color="default" size="small" />
                            )
                          ) : (
                            <Typography variant="body2">
                              {fileDetails.grade
                                ? `${fileDetails.grade}/100`
                                : 'N/A'}
                            </Typography>
                          )}
                        </TableCell>

                        <TableCell>
                          {isQuiz ? '—' : (fileDetails.approver || "N/A")}
                        </TableCell>

                        {/* Action column — uses renderActionCell */}
                        <TableCell align="center">
                          {renderActionCell(row)}
                        </TableCell>
                      </TableRow>
                    );
                  })
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination rowsPerPageOptions={[5, 10, 15]} component="div"
          count={filteredData.length} rowsPerPage={rowsPerPage} page={page}
          onPageChange={(e, n) => setPage(n)}
          onRowsPerPageChange={e => {
            setRowsPerPage(parseInt(e.target.value, 10)); setPage(0);
          }} />
      </Card>

      {/* ── Quiz Attempt Dialog (not reachable by alumni) ───── */}
      <Dialog open={quizOpen} onClose={() => setQuizOpen(false)}
        maxWidth="md" fullWidth
        PaperProps={{ sx: { maxHeight: '90vh' } }}>
        <DialogTitle sx={{ borderBottom: '1px solid #e0e0e0' }}>
          <Typography variant="h6" fontWeight="bold">
            {quizAssessment?.description}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            {quizAssessment?.moduleName} · {quizQuestions.length} questions ·
            Total marks: {quizQuestions.reduce((s, q) => s + (q.marks || 0), 0)}
          </Typography>
        </DialogTitle>

        <DialogContent dividers>
          {quizQuestions.map((q, index) => (
            <Box key={q.id} sx={{
              mb: 3, p: 2.5,
              border: '1px solid #e0e0e0',
              borderRadius: 2, backgroundColor: '#fafafa'
            }}>
              <Box display="flex" justifyContent="space-between"
                alignItems="flex-start" mb={1}>
                <Typography fontWeight="bold" sx={{ flex: 1 }}>
                  Q{index + 1}. {q.questionText}
                </Typography>
                <Chip label={`${q.marks} mark${q.marks > 1 ? 's' : ''}`}
                  size="small" color="info" sx={{ ml: 1 }} />
              </Box>

              {/* MCQ */}
              {q.questionType === 'MCQ' && (
                <RadioGroup value={studentAnswers[q.id] || ''}
                  onChange={e => handleAnswerChange(q.id, e.target.value)}>
                  {q.options?.map((opt, i) => (
                    <FormControlLabel key={i} value={opt.optionText}
                      control={<Radio />} label={opt.optionText} />
                  ))}
                </RadioGroup>
              )}

              {/* TRUE_FALSE */}
              {q.questionType === 'TRUE_FALSE' && (
                <RadioGroup row value={studentAnswers[q.id] || ''}
                  onChange={e => handleAnswerChange(q.id, e.target.value)}>
                  <FormControlLabel value="True"
                    control={<Radio />} label="True" />
                  <FormControlLabel value="False"
                    control={<Radio />} label="False" />
                </RadioGroup>
              )}

              {/* MATCH */}
              {q.questionType === 'MATCH' && (
                <Box>
                  <Typography variant="body2" color="textSecondary" mb={1}>
                    Match each item with the correct answer.
                  </Typography>
                  {q.matchPairs?.map((pair, pi) => (
                    <Box key={pi} display="flex" alignItems="center"
                      gap={2} mb={1}>
                      <Typography sx={{ minWidth: 140, fontWeight: 500 }}>
                        {pair.leftItem}
                      </Typography>
                      <Typography>→</Typography>
                      <TextField select size="small" sx={{ minWidth: 160 }}
                        value={
                          studentAnswers[q.id]
                            ? (JSON.parse(studentAnswers[q.id])[pair.leftItem] || '')
                            : ''
                        }
                        onChange={e =>
                          handleMatchChange(q.id, pair.leftItem, e.target.value)
                        }>
                        <MenuItem value="">-- Select --</MenuItem>
                        {getRightItems(q).map((ri, i) => (
                          <MenuItem key={i} value={ri}>{ri}</MenuItem>
                        ))}
                      </TextField>
                    </Box>
                  ))}
                </Box>
              )}

              {/* SHORT_ANSWER */}
              {q.questionType === 'SHORT_ANSWER' && (
                <TextField multiline rows={3} fullWidth
                  placeholder="Type your answer here..."
                  value={studentAnswers[q.id] || ''}
                  onChange={e => handleAnswerChange(q.id, e.target.value)} />
              )}
            </Box>
          ))}
        </DialogContent>

        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => setQuizOpen(false)} color="inherit">
            Cancel
          </Button>
          <Button variant="contained" color="primary"
            disabled={quizSubmitting} onClick={handleSubmitQuiz}>
            {quizSubmitting
              ? <><CircularProgress size={20} sx={{ mr: 1 }} />Submitting...</>
              : 'Submit Quiz'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Immediate Result after submit ──────────────────── */}
      <Dialog open={quizResultOpen}
        onClose={() => setQuizResultOpen(false)}
        maxWidth="sm" fullWidth>
        <DialogTitle>Quiz Submitted!</DialogTitle>
        <DialogContent>
          {quizResult && (
            <Box textAlign="center" py={2}>
              <Typography variant="h3" fontWeight="bold" color="primary">
                {quizResult.earnedMarks} / {quizResult.totalMarks}
              </Typography>
              <Typography variant="h6" color="textSecondary" mt={1}>
                {quizResult.percentage?.toFixed(1)}%
              </Typography>
              <LinearProgress variant="determinate"
                value={quizResult.percentage || 0}
                sx={{ mt: 2, height: 10, borderRadius: 5 }}
                color={quizResult.percentage >= 50 ? 'success' : 'error'} />
              <Typography mt={2} fontWeight="bold"
                color={quizResult.percentage >= 50 ? 'success.main' : 'error.main'}>
                {quizResult.percentage >= 50 ? '🎉 Passed!' : '❌ Failed!'}
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setQuizResultOpen(false)}
            variant="outlined">Close</Button>
          <Button
            variant="contained" color="success"
            onClick={() => {
              setQuizResultOpen(false);
              if (quizAssessment) handleOpenReview(quizAssessment);
            }}>
            View Detailed Answers
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Detailed Review Dialog ──────────────────────────── */}
      <QuizReviewDialog
        open={reviewOpen}
        onClose={() => setReviewOpen(false)}
        assessmentId={reviewAssessmentId}
        studentId={studentTeacherId}
        assessmentName={reviewAssessmentName}
      />

      <ToastContainer position="bottom-right" autoClose={3000} hideProgressBar />
    </div>
  );
};

export default BatchTable;